







































































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import { ClientPanel, getClientPanelName } from "@/data/models/ClientPanel";
import {
  ProjectDetails,
  ContactPersonInfo,
} from "@/data/models/ProjectDetails";
import {
  ClientPanelAssignment,
  doClientPanelAssignmentsCollide,
  isDateIncludedInOtherAssignment,
} from "@/data/models/ClientPanelAssignment";
import { supportsIot } from "@/data/models/Panel";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

import DatePickerCompoment from "@/components/common/DatePicker.vue";
import { generateRandomUuid } from "@/utils/Utils";
import {
  getPanel,
  getMeterReadingInKWhForDate,
  MeterReadingInfo,
} from "@/data/repository/PanelRepository";
import {
  loadAssignmentsEndedAfter,
  getFirstAssignmentEndedBefore,
  getFirstAssignmentEndedAfter,
  saveOrUpdateClientPanelAssignment,
  deleteClientPanelAssignments,
  getAllAssignmentsStartedOrEndedAfter,
  getClientPanelAssignmentsOfProject,
} from "@/data/repository/ClientPanelAssignmentRepository";
import {
  getGenericDeviceAssignmentsOfProject,
} from "@/data/repository/GenericDeviceAssignmentRepository";
import { DeviceProjectAssignment } from "@/data/models/DeviceProjectAssignment";
import { restoreProposedMeterReading } from "@/data/models/MeterReading";
import {
  hasActiveDependentAssignments as _hasActiveDependents,
  getLatestDependentAssignmentEndDate as _getLatestDependentEnd,
} from "@/utils/CountingDeviceValidation";

import clone from "clone";

import { createTerminateComBoxDryRunCommand } from "@/utils/combox/commands/ComBoxCommands";
import { buildStopPanelCommand } from "@/utils/panel/commands/CommandBuilder";
import { IresDeviceRequestType } from "@/data/models/PanelRequest";
import { createPanelActionRequest } from "@/data/repository/PanelRequestRepository";

import { formatFloat, parseLocalizedFloat } from "@/utils/LocalisationHelper";
import {
  formatJsDate,
  formatDateShort,
  formatDateAndMonth,
  toDatePickerFormat,
} from "@/utils/DateFormatter";
import {
  toStartOfDay,
  toEndOfDay,
  areOnSameDay,
  areDatesOnSameDay,
} from "@/utils/DateHelper";
import { firestore } from "firebase/app";

import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import {
  didIresDeviceTimeOut,
  getIresDeviceCategoryFromSerialNumber,
  IresDevice,
  IresDeviceCategory,
} from "@/data/models/IresDevice";
import { getComBox } from "@/data/repository/ComBoxRepository";
import {
  getFirstProgramChainStartedBefore,
  getMostRecentProgramChain,
  getProgramChainsInClosedTimeRange,
  getUnassignedProgramChainsInOpenTimeRange,
} from "@/data/repository/ProgramChainRepository";
import {
  doesProgramChainIncludeActiveRun,
  getEndDateOfProgramChain,
  getInitialMeterReadingOfProgramChain,
  getLatestMeterReadingOfProgramChain,
  ProgramChain,
} from "@/data/models/ProgramChain";

import { findUser, getActiveUser, getRecordInfo } from "@/data/repository/UserRepository";
import { RecordInfo } from "@/data/models/RecordInfo";
import { getAllAssignmentsOfCurrentClient } from "@/data/repository/IresDeviceAssignmentRepository";
import { getClientId } from "@/data/repository/ClientRepository";
import { IresDeviceAssignment } from "@/data/models/IresDeviceAssignment";
import { alwaysAllowedToCorrectMeterReadingsAccess, skipAssignmentDataValidationAccess } from "@/permissions/UserPermissions";
import { canBeUsedAsElectricityMeterForOtherDevices } from "@/data/models/DeviceTemplate";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { getTemplate } from "@/data/repository/GenericDeviceRepository";
import { getCategoryIdFromSerialNumber, getTemplateIdFromSerialNumber } from "@/data/models/DeviceSettingsManager";
import { UserModule } from "@/store/modules/UserModule";
import { MASTER_ID } from "@/data/models/User";

enum AssignmentValidationResult {
  NotValidated,
  SaveData,
  SaveEnabled,
  SaveDisabled,
}

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    "date-picker": DatePickerCompoment,
    "base-dialog": BaseDialogComponent,
  },
})
export default class AssignIresDeviceToProjectComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirmationDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Ref("endDatePicker")
  endDatePicker!: DatePickerCompoment;

  @Ref("startDatePicker")
  startDatePicker!: DatePickerCompoment;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  startedForAssignmentCreation = true;
  startedForAssignmentCorrection = true;

  iresDevice!: IresDevice;
  clientPanelToAssign!: ClientPanel;
  targetProject!: ProjectDetails;
  contactPerson!: ContactPersonInfo;
  assignment!: ClientPanelAssignment;
  existingAssignments: ClientPanelAssignment[] = [];
  allDeviceAssignmentsToClient: IresDeviceAssignment[] = [];

  didLoadDeviceInfo = false;
  minDate: firestore.Timestamp | null = null;

  startDate = firestore.Timestamp.fromDate(new Date());
  endDate: firestore.Timestamp | null = null;

  maxEndDate = firestore.Timestamp.fromDate(new Date());

  didValidateStartDate = false;
  didValidateEndDate = false;

  assignmentValidationResult = AssignmentValidationResult.NotValidated;

  showContent = false;

  wasActiveAssignment = false;
  
  proposedMeterReadingStart: MeterReadingInfo = this.createEmptyMeterReadingInput();
  proposedMeterReadingEnd: MeterReadingInfo = this.createEmptyMeterReadingInput();
  meterReadingStart: MeterReadingInfo = this.createEmptyMeterReadingInput();
  meterReadingEnd: MeterReadingInfo = this.createEmptyMeterReadingInput();

  lastMeterReadingEndTargetDate: firestore.Timestamp | null = null;
  lastMeterReadingStartTargetDate: firestore.Timestamp | null = null;

  electricityMeterNumber: string | null = null;

  meterReadingEndInput = "";
  meterReadingStartInput = "";
  meterReadingEndError: string[] = [];

  powerConsumption = 0;

  showProgressBar = false;

  meterReadingStartCorrectedBy: null | RecordInfo = null;
  meterReadingEndCorrectedBy: null | RecordInfo = null;

  serialNumber = "";

  countedDeviceAssignments: DeviceProjectAssignment[] = [];

  get activeUser() {
    return getActiveUser();
  }

  get isAlwaysAllowedToCorrectMeterReadings() {
    return alwaysAllowedToCorrectMeterReadingsAccess(this.activeUser);
  }

  get isAllowedToSkipAssignmentDataValidation() {
    return skipAssignmentDataValidationAccess(this.activeUser);
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get deviceSettingsJson() {
    return this.isAllowedToDefineOwnDeviceCategoriesAndTemplates
      ? this.localDeviceSettingsJson
      : this.sharedDeviceSettingsJson;
  }

  get canMeterReadingStartBeCorrected() {
    if (this.isAlwaysAllowedToCorrectMeterReadings) {
      return true;
    }

    if (!this.startedForAssignmentCreation) {
      return false;
    }

    return this.meterReadingStart.canBeCorrected === true;
  }

  get canMeterReadingEndBeCorrected() {
    if (this.isAlwaysAllowedToCorrectMeterReadings) {
      return true;
    }

    return this.meterReadingEnd.canBeCorrected === true;
  }

  get saveDisabled() {
    return (
      this.assignmentValidationResult ===
      AssignmentValidationResult.SaveDisabled
    );
  }

  
  get allowedStartDates() {
    const dates = this.calculateStartDates(false);
    
    return (val: string) => dates.includes(val);
  }

  get allowedEndDates() {
    const dates = this.calculateStartDates(true);
    const minEnd = this.minEndDateString;
    
    return (val: string) => {
      if (minEnd && val < minEnd) {
        return false;
      }
      return dates.includes(val);
    };
  }

  get isCountingDevice() {
    return this.assignment?.electricityMeterForOtherDevices === true;
  }

  get isReleaseMode() {
    return !this.startedForAssignmentCreation && !this.startedForAssignmentCorrection;
  }

  get hasActiveDependentAssignments(): boolean {
    return _hasActiveDependents(this.isCountingDevice, this.countedDeviceAssignments);
  }

  get latestDependentAssignmentEndDate(): firestore.Timestamp | null {
    return _getLatestDependentEnd(this.isCountingDevice, this.countedDeviceAssignments);
  }

  get minEndDateString(): string | null {
    const latestDependentEnd = this.latestDependentAssignmentEndDate;
    if (!latestDependentEnd) return null;
    return toDatePickerFormat(toStartOfDay(latestDependentEnd).toDate());
  }

  get minEndDate(): firestore.Timestamp {
    const latestDependentEnd = this.latestDependentAssignmentEndDate;
    if (
      latestDependentEnd &&
      latestDependentEnd.toMillis() > this.startDate.toMillis()
    ) {
      return toStartOfDay(latestDependentEnd);
    }
    return this.startDate;
  }

  // Device assignment is only permitted if the device is currently assigned to the client in question.
  calculateStartDates(isForEndDate: boolean) {
    const dates: string[] = [];
    const datesToBeSkipped: string[] = [];
    
    this.allDeviceAssignmentsToClient.forEach((_, index, arr) => {
      const assignment = arr[arr.length - 1 - index];

      // Measure that the assignment dates do not overlap.
      const isAssignmentRelevant = !isForEndDate ||
        (
          this.startDate.toDate() >= assignment.startDate.toDate() &&
          (
            !assignment.endDate || 
            this.startDate.toDate() <= assignment.endDate.toDate()
          )
        );

      if (assignment.startDate && isAssignmentRelevant) {
        const assignmentStartDate = new Date(assignment.startDate.toDate());
        const minDate = this.minDate?.toDate();
        
        // Use the later start date between the project and the assignment
        let currentDate = minDate && minDate > assignmentStartDate ? minDate : assignmentStartDate;
        let endDate: Date;

        if (assignment.endDate) {
          endDate = new Date(assignment.endDate.toDate());
        } else {
          endDate = this.maxEndDate.toDate();
        }

        // Adjust the dates for comparison
        currentDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        /*
        * Adjust the timezone difference
        * Current date: GMT+0100 Central European Standard Time (CET)
        * Current date (ISO 8601): GMT+0000 Universal Time (UTC)
        */
        currentDate.setDate(currentDate.getDate() + 1);
        
        // Include end date in allowed dates
        endDate.setDate(endDate.getDate() + 1);
        
        while (currentDate <= endDate) {
          // Format as 'YYYY-MM-DD'
          const dateToBeAdded = currentDate.toISOString().split('T')[0];
          if (!datesToBeSkipped.includes(dateToBeAdded) || isForEndDate) {
            dates.push(dateToBeAdded);
          }

          const timestampToBeChecked = firestore.Timestamp.fromDate(currentDate);

          /*
          * Adjust the timezone difference
          * Current date: GMT+0100 Central European Standard Time (CET)
          * Current date (ISO 8601): GMT+0000 Universal Time (UTC)
          */
          currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));

          this.existingAssignments.forEach((existingAssignment) => {
            if (
              isDateIncludedInOtherAssignment(
                timestampToBeChecked,
                existingAssignment
              )
            ) {
              // Avoid overlapping device assignments to the project
              const dateToBeSkipped = currentDate.toISOString().split('T')[0];
              datesToBeSkipped.push(dateToBeSkipped);
            }
          });
        }
      }
    });

    return dates;
  }

  async validateAssignmentData(
    date: firestore.Timestamp,
    validateStartDate: boolean,
    programChains?: ProgramChain[],
    ignoreShowingConfifirmationDialog?: boolean,
  ) {
    if (validateStartDate) {
      this.didValidateStartDate = true;
    } else {
      this.didValidateEndDate = true;
    }

    let assignmentValidationResult: AssignmentValidationResult =
      AssignmentValidationResult.SaveDisabled;

    if (validateStartDate) {
      assignmentValidationResult = await this.validateStartDate(this.startDate, ignoreShowingConfifirmationDialog);
    } else if (this.endDate) {
      assignmentValidationResult = await this.validateEndDate(
        programChains ?? [],
        this.endDate
      );

      if (
        assignmentValidationResult !== AssignmentValidationResult.SaveDisabled
      ) {
        //Validate meter reading input
        const totalPowerConsumption = this.totalPowerConsumption;

        if (totalPowerConsumption !== null && totalPowerConsumption < 0) {
          assignmentValidationResult = AssignmentValidationResult.SaveDisabled;
        }
      }
    }

    // Always enable save button for IRES admin
    this.assignmentValidationResult = this.isAllowedToSkipAssignmentDataValidation
      ? AssignmentValidationResult.SaveEnabled
      : assignmentValidationResult;
  }

  get maxAssignmentStartDate() {
    return this.endDate ?? this.maxEndDate;
  }

  get meterReadingStartInfo() {
    return this.formatMeterReadingInfo(
      this.meterReadingStart,
      this.meterReadingStartCorrectedBy
    );
  }

  get meterReadingEndInfo() {
    return this.formatMeterReadingInfo(
      this.meterReadingEnd,
      this.meterReadingEndCorrectedBy
    );
  }

  get doesPanelSupportIot() {
    return supportsIot(this.iresDevice);
  }

  get powerConsumptionTitle() {
    return this.$t(
      this.doesPanelSupportIot
        ? "assignDevice.powerConsumptionRemote"
        : "assignDevice.powerConsumption"
    );
  }

  get totalPowerConsumption() {
    const start = this.meterReadingStartInputInKwh;
    const end = this.meterReadingEndInputInKwh;

    if (isNaN(end) || isNaN(start)) {
      return null;
    }

    return end - start;
  }

  get totalPowerConsumptionString() {
    const totalPowerConsumption = this.totalPowerConsumption;

    if (totalPowerConsumption == null) {
      return null;
    }

    return formatFloat(totalPowerConsumption, 2);
  }

  formatMeterReadingInfo(
    meterReadingInfo: MeterReadingInfo | null,
    correctedBy: RecordInfo | null
  ) {
    if (correctedBy) {
      return `(${this.$t("assignDevice.correctedBy", [
        findUser(correctedBy.recordedByUserId)?.nickname,
        formatJsDate(correctedBy.recordedAt.toDate(), true),
      ]).toString()})`;
    }

    if (!meterReadingInfo) {
      return null;
    }

    if (meterReadingInfo.date) {
      if (meterReadingInfo.projectName) {
        return `(${this.$t("assignDevice.meterReadingFromAssignment", [
          meterReadingInfo.projectName,
          formatDateAndMonth(meterReadingInfo.date.toDate()),
        ]).toString()})`;
      }

      return `(${this.$t("assignDevice.meterReadingFromIot", [
        formatJsDate(meterReadingInfo.date.toDate()),
      ]).toString()})`;
    } else {
      return "";
    }
  }

  async showNoUnassignedProgramChainFoundDialog() {
    return this.confirmationDialog.show({
      title: this.$t("assignDevice.errorStartDateTitle").toString(),
      message: this.$t(
        "assignDevice.noUnassignedProgramChainFoundMessage"
      ).toString(),
      acceptMessage: this.$t("assignIresDevice.assignAnyway").toString(),
      rejectMessage: this.$t("common.abort").toString(),
    });
  }

  async loadProgramChainsForAssignment(
    startDate: firestore.Timestamp,
    endDate: firestore.Timestamp | null
  ) {
    if (!endDate) {
      return await getUnassignedProgramChainsInOpenTimeRange(
        this.serialNumber,
        startDate,
        this.startedForAssignmentCreation ? undefined : this.assignment?.id
      );
    }

    let programChainsInAssignment = await getProgramChainsInClosedTimeRange(
      this.assignment.id,
      this.serialNumber,
      startDate,
      endDate
    );

    if (programChainsInAssignment.length > 0) {
      //If the latest program chain was started on the day of the assignment and ended after that day
      //or is still active we want to exclude it from this assignment.
      //In that case we also want to exclude all other program chains that were started
      //on that day from this assignment
      const lastProgramChain =
        programChainsInAssignment[programChainsInAssignment.length - 1];

      const wasStartedOnAssignmentEndDay = areOnSameDay(
        lastProgramChain.startDate,
        endDate
      );

      if (wasStartedOnAssignmentEndDay) {
        const mightEndAfterAssignmentEnd =
          doesProgramChainIncludeActiveRun(lastProgramChain) ||
          getEndDateOfProgramChain(lastProgramChain).toMillis() >
            endDate.toMillis();

        if (mightEndAfterAssignmentEnd) {
          //Remove all program chains that were started on assignment end date.
          //Those program chains should be excluded from this assignment
          programChainsInAssignment = programChainsInAssignment.filter(
            (programChain) => !areOnSameDay(endDate, programChain.startDate)
          );
        }
      }
    }

    return {
      filteredProgramChains: programChainsInAssignment,
      allProgramChains: programChainsInAssignment,
    };
  }

  async onStartDateChanged(newStartDate: firestore.Timestamp, ignoreShowingConfifirmationDialog?: boolean) {
    this.showProgressBar = true;

    const {
      allProgramChains,
      filteredProgramChains,
    } = await this.loadProgramChainsForAssignment(newStartDate, this.endDate);

    this.showProgressBar = false;

    if (allProgramChains.length === 0) {
      await this.onNewStartDateSet(newStartDate, allProgramChains);
    } else if (filteredProgramChains.length === 0) {
      this.meterReadingStart = this.createEmptyMeterReadingInput();
      const latestProgramChain = allProgramChains[allProgramChains.length - 1];

      if (latestProgramChain) {
        const latestMeterReading = getLatestMeterReadingOfProgramChain(
          latestProgramChain
        );

        if (latestMeterReading) {
          this.meterReadingStart = {
            ...latestMeterReading,
            canBeCorrected: true,
          };
          this.proposedMeterReadingStart = this.meterReadingStart;
        }
      }
    } else {
      await this.onNewStartDateSet(newStartDate, filteredProgramChains);
    }

    await this.validateAssignmentData(newStartDate, true, undefined, ignoreShowingConfifirmationDialog);
  }

  async onNewStartDateSet(
    date: firestore.Timestamp,
    programChains: ProgramChain[]
  ) {
    this.meterReadingStart = this.createEmptyMeterReadingInput();

    if (
      areOnSameDay(toStartOfDay(date), this.assignment.assignmentStartDate) &&
      this.assignment.meterReadingInfo?.meterReadingStartKWh !== undefined
    ) {
      this.meterReadingStart = {
        meterReadingInKWh: this.assignment.meterReadingInfo
          .meterReadingStartKWh,
      };
      this.proposedMeterReadingStart = this.meterReadingStart;

      return;
    }

    const firstProgramChainAfterStartDate = programChains[0];

    if (firstProgramChainAfterStartDate) {
      const meterReadingInfo = getInitialMeterReadingOfProgramChain(
        firstProgramChainAfterStartDate
      );

      if (meterReadingInfo) {
        this.meterReadingStart = meterReadingInfo;
        this.proposedMeterReadingStart = this.meterReadingStart;
        return;
      }
    }

    const firstProgramChainStartedBefore = await getFirstProgramChainStartedBefore(
      this.iresDevice.serialNo,
      firestore.Timestamp.now()
    );

    if (firstProgramChainStartedBefore) {
      const latestMeterReading = getLatestMeterReadingOfProgramChain(
        firstProgramChainStartedBefore
      );

      if (latestMeterReading) {
        this.meterReadingStart = {
          ...latestMeterReading,
          canBeCorrected: true,
        };
        this.proposedMeterReadingStart = this.meterReadingStart;
        return;
      }
    }

    const mostRecentProgramChain = await getMostRecentProgramChain(
      this.iresDevice.serialNo
    );

    if (mostRecentProgramChain) {
      const latestMeterReading = getLatestMeterReadingOfProgramChain(
        mostRecentProgramChain
      );

      if (latestMeterReading) {
        this.meterReadingStart = {
          ...latestMeterReading,
          canBeCorrected: true,
        };
        this.proposedMeterReadingStart = this.meterReadingStart;
        return;
      }
    }

    if (this.doesPanelSupportIot) {
      this.meterReadingStart =
        (await getMeterReadingInKWhForDate(this.iresDevice, date, false)) ??
        this.createEmptyMeterReadingInput();
    } else {
      const panelAssignment = await getFirstAssignmentEndedBefore(
        this.iresDevice.serialNo,
        date
      );

      if (panelAssignment && panelAssignment.assignmentEndDate) {
        if (panelAssignment.meterReadingInfo?.meterReadingEndKWh) {
          this.meterReadingStart = {
            meterReadingInKWh:
              panelAssignment.meterReadingInfo.meterReadingEndKWh,
            date: panelAssignment.assignmentEndDate,
            projectName: panelAssignment.assignedProjectName,
          };
        }
      }
    }

    this.proposedMeterReadingStart = this.meterReadingStart;
  }

  @Watch("meterReadingStart")
  onMeterReadingStartChanged(meterReadingStart: MeterReadingInfo) {
    if (!meterReadingStart.ignoreCorrectedBy) {
      this.meterReadingStartCorrectedBy = null;
    }
    this.meterReadingStartInput = formatFloat(
      meterReadingStart.meterReadingInKWh,
      2
    );
  }

  @Watch("meterReadingEnd")
  onMeterReadingEndChanged(meterReadingEnd: MeterReadingInfo) {
    if (!meterReadingEnd.ignoreCorrectedBy) {
      this.meterReadingEndCorrectedBy = null;
    }

    // Truthiness would drop a proposed 0, which is a reading like any other: a drying that consumed
    // nothing ends where it started. The field then looked empty while the model held the proposal,
    // so the reading appeared not to be proposed at all. The start reading opposite has always been
    // written unconditionally, and the generic-device dialog tests the same way this does.
    if (
      typeof meterReadingEnd.meterReadingInKWh === "number" &&
      !isNaN(meterReadingEnd.meterReadingInKWh)
    ) {
      this.meterReadingEndInput = formatFloat(
        meterReadingEnd.meterReadingInKWh,
        2
      );
    }
  }

  @Watch("startDate")
  onStartDatePicked() {
    if (!this.startedForAssignmentCreation) {
      this.updateMaxEndDate();
    }
  }

  async onEndDateChanged(date: firestore.Timestamp, ignoreEndDateProposal?: boolean) {
    if (!date) {
      return;
    }

    const newEndDate = toEndOfDay(date);

    if (!ignoreEndDateProposal) {
      this.meterReadingEndCorrectedBy = null;

      // Correctable here too, not only after the await below. This is what the field shows while the
      // chains load, and handing it a reading with no flag is what made it visibly lock a moment
      // after it appeared.
      this.meterReadingEnd = { ...this.meterReadingStart, canBeCorrected: true };
    }

    const programChainsInAssignment = (
      await this.loadProgramChainsForAssignment(this.startDate, newEndDate)
    ).filteredProgramChains;

    const latestProgramChain =
      programChainsInAssignment[programChainsInAssignment.length - 1];

    if (!ignoreEndDateProposal) {
      this.meterReadingEndCorrectedBy = null;

      // Correctable, like the start reading on every path that sets it, and like the end reading on
      // the two release paths that already enable it. The drying still supplies the proposal; what
      // this restores is the ability to overwrite it. Without it the field is read-only whenever the
      // assignment holds a drying that reported a reading at all - and a reading of 0 is a reading,
      // so a drying that drew no power left the release with a locked, unusable 0.
      const proposedEnd = latestProgramChain
        ? getLatestMeterReadingOfProgramChain(latestProgramChain) ??
          this.meterReadingStart
        : this.meterReadingStart;

      this.meterReadingEnd = { ...proposedEnd, canBeCorrected: true };
    }

    this.proposedMeterReadingEnd = latestProgramChain
      ? getLatestMeterReadingOfProgramChain(latestProgramChain) ??
        this.meterReadingStart
      : this.meterReadingStart;

    this.validateMeterReadingEnd();

    await this.validateAssignmentData(date, false, programChainsInAssignment);
  }

  async deleteThisAssignment() {
    this.showProgressBar = true;

    await deleteClientPanelAssignments(this.targetProject, [this.assignment]);

    this.showProgressBar = false;

    this.onCancel();
  }

  async validateStartDate(
    newStartDate: firestore.Timestamp,
    ignoreShowingConfifirmationDialog?: boolean,
  ): Promise<AssignmentValidationResult> {
    const firstAssignmentEndedAfter = await getFirstAssignmentEndedAfter(
      this.serialNumber,
      toEndOfDay(newStartDate)
    );

    if (firstAssignmentEndedAfter) {
      if (this.startedForAssignmentCreation) {
        if (
          isDateIncludedInOtherAssignment(
            toStartOfDay(newStartDate),
            firstAssignmentEndedAfter
          )
        ) {
          await this.showCollidingAssignmentInfo(
            newStartDate,
            firstAssignmentEndedAfter
          );

          return AssignmentValidationResult.SaveDisabled;
        }
      } else {
        if (
          firstAssignmentEndedAfter.id !== this.assignment.id &&
          doClientPanelAssignmentsCollide(
            newStartDate,
            this.endDate,
            firstAssignmentEndedAfter
          )
        ) {
          await this.showCollidingAssignmentInfo(
            newStartDate,
            firstAssignmentEndedAfter
          );

          return AssignmentValidationResult.SaveDisabled;
        }
      }
    }

    const firstProgramChainStartedBefore = await getFirstProgramChainStartedBefore(
      this.serialNumber,
      newStartDate
    );

    const endOfNewStartDate = toEndOfDay(newStartDate);

    if (firstProgramChainStartedBefore) {
      const active = doesProgramChainIncludeActiveRun(
        firstProgramChainStartedBefore
      );
      const endDateOfProgramChain = getEndDateOfProgramChain(
        firstProgramChainStartedBefore
      );

      if (
        firstProgramChainStartedBefore.startDate.toMillis() <
          toStartOfDay(newStartDate).toMillis() &&
        (active ||
          toEndOfDay(endDateOfProgramChain).toMillis() >
            endOfNewStartDate.toMillis())
      ) {
        const formattedDate = formatDateShort(newStartDate);
        const chainStartDate = formatDateShort(
          firstProgramChainStartedBefore.startDate
        );

        const chainEndDate = formatDateShort(
          getEndDateOfProgramChain(firstProgramChainStartedBefore)
        );

        this.meterReadingStart =
          getLatestMeterReadingOfProgramChain(firstProgramChainStartedBefore) ??
          this.meterReadingStart;
        this.proposedMeterReadingStart = this.meterReadingStart;

        const assignAnyway = !ignoreShowingConfifirmationDialog
          ? await this.confirmationDialog.show({
            title: this.$t("assignDevice.errorStartDateTitle").toString(),
            message: this.$t(
              `assignIresDevice.${
                active
                  ? "dialogOverlappingProgramChainMessage"
                  : "dialogOverlappingProgramChainFinishedMessage"
              }`,
              [
                formattedDate,
                firstProgramChainStartedBefore.chainNumber,
                chainStartDate,
                chainEndDate,
              ]
            ).toString(),
            cancelable: false,
            rejectMessage: this.$t("common.abort").toString(),
            acceptMessage: this.$t("assignIresDevice.assignAnyway").toString(),
          })
          : true;

        if (assignAnyway) {
          this.meterReadingStart = {
            ...this.meterReadingStart,
            canBeCorrected: true,
          };

          this.proposedMeterReadingStart = this.meterReadingStart;
        }

        return assignAnyway
          ? AssignmentValidationResult.SaveEnabled
          : AssignmentValidationResult.SaveDisabled;
      }
    }

    const {
      allProgramChains,
      filteredProgramChains,
    } = await this.loadProgramChainsForAssignment(newStartDate, this.endDate);

    if (allProgramChains.length === 0) {
      return AssignmentValidationResult.SaveData;
    } else if (filteredProgramChains.length === 0) {
      const assignAnyway = await this.showNoUnassignedProgramChainFoundDialog();

      if (assignAnyway) {
        this.meterReadingStart = {
          ...this.meterReadingStart,
          canBeCorrected: true,
        };
        this.proposedMeterReadingStart = this.meterReadingStart;
      }

      return assignAnyway
        ? AssignmentValidationResult.SaveEnabled
        : AssignmentValidationResult.SaveDisabled;
    } else {
      return AssignmentValidationResult.SaveData;
    }
  }

  async validateEndDate(
    programChains: ProgramChain[],
    newEndDate: firestore.Timestamp
  ): Promise<AssignmentValidationResult> {
    if (
      this.assignment.assignmentEndDate &&
      areOnSameDay(this.assignment.assignmentEndDate, newEndDate)
    ) {
      return AssignmentValidationResult.SaveData;
    }

    const otherAssignmentsEndedAfterAssignmentStartDate = await loadAssignmentsEndedAfter(
      this.serialNumber,
      this.assignment.id,
      toStartOfDay(this.assignment.assignmentStartDate)
    );

    const collidingAssignments = otherAssignmentsEndedAfterAssignmentStartDate.filter(
      (assignment) =>
        doClientPanelAssignmentsCollide(
          this.assignment.assignmentStartDate,
          newEndDate,
          assignment
        )
    );

    if (collidingAssignments.length > 0) {
      const firstCollidingAssignment = collidingAssignments[0];
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t("assignDevice.collidingAssignment", [
          formatDateShort(newEndDate),
          formatDateShort(firstCollidingAssignment.assignmentStartDate),
        ]).toString(),
        acceptMessage: null,
        rejectMessage: this.$t("common.abort").toString(),
      });

      return AssignmentValidationResult.SaveDisabled;
    }

    if (programChains.length === 0) {
      this.meterReadingEndCorrectedBy = null;
      this.meterReadingEnd = this.meterReadingStart;
      this.proposedMeterReadingEnd = this.meterReadingEnd;

      const releaseAnyway = await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t(
          "openProgramChainDecision.noProgramChainsFoundInAssignmentRange"
        ).toString(),
        rejectMessage: this.$t("common.abort").toString(),
        acceptMessage: this.$t("assignIresDevice.releaseAnyway").toString(),
      });

      if (releaseAnyway) {
        this.meterReadingEnd = {
          ...this.meterReadingEnd,
          canBeCorrected: true,
        };
      }

      return releaseAnyway
        ? AssignmentValidationResult.SaveEnabled
        : AssignmentValidationResult.SaveDisabled;
    } else {
      const latestProgramChain = programChains[programChains.length - 1];
      const isActive = doesProgramChainIncludeActiveRun(latestProgramChain);

      const endDateAtStartOfDay = toStartOfDay(newEndDate).toMillis();

      const endsAfterAssignmentEnd =
        getEndDateOfProgramChain(latestProgramChain).toMillis() >
        toEndOfDay(newEndDate).toMillis();

      if (isActive || endsAfterAssignmentEnd) {
        const wasStartedOnAssignmentEndDate =
          latestProgramChain.startDate.toMillis() >= endDateAtStartOfDay;

        if (!wasStartedOnAssignmentEndDate) {
          if (isActive) {
            return await this.onActiveProgramChainStartedBeforeAssignmentEnd(
              newEndDate,
              latestProgramChain
            );
          } else {
            const formattedDate = formatDateShort(newEndDate);
            const chainStartDate = formatDateShort(
              latestProgramChain.startDate
            );

            const chainEndDate = formatDateShort(
              getEndDateOfProgramChain(latestProgramChain)
            );

            const assignAnyway = await this.confirmationDialog.show({
              title: this.$t("assignDevice.errorEndDateTitle").toString(),
              message: this.$t(
                `assignIresDevice.dialogIncludeOverlappingProgramChainFinishedMessage`,
                [
                  formattedDate,
                  latestProgramChain.chainNumber,
                  chainStartDate,
                  chainEndDate,
                ]
              ).toString(),
              cancelable: false,
              rejectMessage: this.$t("common.abort").toString(),
              acceptMessage: this.$t(
                "assignIresDevice.releaseAnyway"
              ).toString(),
            });

            return assignAnyway
              ? AssignmentValidationResult.SaveEnabled
              : AssignmentValidationResult.SaveDisabled;
          }
        }
      } else {
        return AssignmentValidationResult.SaveData;
      }

      return AssignmentValidationResult.SaveData;
    }
  }

  calculateBaseDialogTitle() {
    const iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
      this.clientPanelToAssign.serialNumber
    );

    const isPanel = iresDeviceCategory === IresDeviceCategory.PANEL;
    const isStartedForAssignmentCreation = this.startedForAssignmentCreation;
    const isStartedForAssignmentCrorrection = this.startedForAssignmentCorrection;

    return (this.$t(
      `assignDevice.format${
        isStartedForAssignmentCreation 
          ? 'Assign' 
          : isStartedForAssignmentCrorrection 
            ? 'Correction' 
            : 'SignOff'
      }${
        isPanel 
          ? 'Panel' 
          : 'ComBox'
      }`, [getClientPanelName(this.clientPanelToAssign)]).toString());
  }

  async show(
    clientPanelToAssign: ClientPanel,
    targetProject: ProjectDetails,
    contactPerson: ContactPersonInfo,
    nextAssignmentIndex: number,
    existingAssignment?: ClientPanelAssignment,
    hasDependantAssignments?: boolean,
    // Room of a new assignment under room-level device assignment; an edit keeps the stored one.
    roomId: string | null = null,
  ) {
    this.serialNumber = clientPanelToAssign.serialNumber;
    this.lastMeterReadingEndTargetDate = null;
    this.lastMeterReadingStartTargetDate = null;

    this.clientPanelToAssign = clientPanelToAssign;
    this.targetProject = targetProject;
    this.contactPerson = contactPerson;
    this.didLoadDeviceInfo = false;

    this.meterReadingEndError = [];
    this.meterReadingEndInput = "";
    this.meterReadingStartInput = "";
    this.electricityMeterNumber = clientPanelToAssign.electricityMeterNumber ?? null;

    this.meterReadingStart = this.createEmptyMeterReadingInput();
    this.meterReadingEnd = this.createEmptyMeterReadingInput();

    const deviceTemplate = getTemplate(
      this.deviceSettingsJson,
      getCategoryIdFromSerialNumber(clientPanelToAssign.serialNumber),
      getTemplateIdFromSerialNumber(clientPanelToAssign.serialNumber)
    );

    this.assignment = existingAssignment ?? {
      id: generateRandomUuid(),
      assignedProjectName: targetProject.clientData.projectName ?? "",
      assignedProjectNumber: targetProject.clientData.projectNumber ?? "",
      assignedProjectId: targetProject.id,
      assignmentIndex: nextAssignmentIndex,
      contactPersonId: contactPerson.id,
      roomId,
      serialNumber: clientPanelToAssign.serialNumber,
      inventoryNumber: clientPanelToAssign.inventoryNumber,
      assignmentStartDate: firestore.Timestamp.fromDate(new Date()),
      wasSingedOffByUser: null,
      assignmentEndDate: null,
      meterReadingInfo: null,
      powerConsumptionInKWh: null,
      electricityMeterNumber: clientPanelToAssign.electricityMeterNumber ?? null,
      createdBy: { 
        recordedAt: firestore.Timestamp.fromDate(new Date()),
        recordedByUserId: getActiveUser()?.id ?? ""
      },
      electricityMeterForOtherDevices: deviceTemplate
        ? canBeUsedAsElectricityMeterForOtherDevices(deviceTemplate)
        : false,
      externalElectricityMeterInfo: null,
    };

    //Delay to fix lag when dialog gets opened
    await new Promise((resolve) => setTimeout(resolve, 300));

    this.powerConsumption = this.assignment.powerConsumptionInKWh ?? 0;

    this.startDate = this.assignment.assignmentStartDate;
    this.endDate = this.assignment.assignmentEndDate;

    this.startedForAssignmentCreation = !existingAssignment;
    this.startedForAssignmentCorrection = !!existingAssignment?.assignmentEndDate;

    if (existingAssignment) {
      this.wasActiveAssignment = existingAssignment.assignmentEndDate === null;
    }

    const projectStartDate = targetProject.clientData.projectStartDate;
    this.minDate = projectStartDate;

    this.existingAssignments = (await getAllAssignmentsStartedOrEndedAfter(
      clientPanelToAssign.serialNumber,
      projectStartDate
    )).filter((existingAssignment) => this.assignment.id !== existingAssignment.id);

    if (this.startedForAssignmentCorrection) {
      // If there is an open assignment, don't consider it.
      this.existingAssignments = this.existingAssignments.filter((existingAssignment) => existingAssignment.assignmentEndDate);
    }

    // If there was an ongoing assignment at the start date of the project, the earliest possible start date 
    // for this assignment would be the end date of the previous assignment.
    if (
      this.existingAssignments.length > 0 && 
      this.existingAssignments[0].assignmentEndDate && 
      this.existingAssignments[0].assignmentStartDate &&
      this.existingAssignments[0].assignmentStartDate.toMillis() <= this.minDate.toMillis() &&
      this.existingAssignments[0].assignmentEndDate.toMillis() >= this.minDate.toMillis()
    ) {
      this.minDate = this.existingAssignments[0].assignmentEndDate;
    }

    // For backward assignment, the proposed release date is set to the start date of the next assignment.
    if (!this.startedForAssignmentCreation && !this.startedForAssignmentCorrection) {
      for (const existingAssignment of this.existingAssignments) {
        if (existingAssignment.assignmentStartDate.toMillis() >= this.startDate.toMillis()) {
          this.endDate = existingAssignment.assignmentStartDate;
          break;
        }
      }
    }

    const didLoadIresDevice = await this.loadIresDeviceAndAssignmentInfo();

    await this.loadCountedDeviceAssignments();

    // Counting devices cannot be released while dependent devices are still active.
    if (this.isReleaseMode && this.isCountingDevice && this.hasActiveDependentAssignments) {
      await this.confirmationDialog.show({
        title: this.$t("assignDevice.errorEndDateTitle").toString(),
        message: this.$t("assignDevice.countingDeviceHasActiveDependentsError").toString(),
        acceptMessage: null,
        rejectMessage: null,
      });
      return false;
    }

    this.showContent = true;
    this.baseDialogComponent.show({
      title: this.calculateBaseDialogTitle(),
      closeOnSave: false,
      maxWidth: 700,
      neutralButtonText: this.startedForAssignmentCreation || hasDependantAssignments
        ? undefined
        : this.$t("common.delete").toString(),
      persistent: false,
    });

    this.showProgressBar = true;

    if (!didLoadIresDevice) {
      this.showProgressBar = false;
      this.baseDialogComponent.isShowing = false;
      this.showContent = false;

      return false;
    }

    await this.setupMeterReadingInfo();

    if (!this.startedForAssignmentCreation && !this.endDate) {
      const newEndDate = firestore.Timestamp.fromDate(new Date());

      this.onEndDateChanged(newEndDate);
      this.endDatePicker.setNewTimestamp(newEndDate);
    }
    else if (!this.startedForAssignmentCreation && this.endDate) {
      this.onEndDateChanged(this.endDate, true);
    }

    this.showProgressBar = false;

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async loadIresDevice(): Promise<IresDevice> {
    const serialNumber = this.clientPanelToAssign.serialNumber;

    return getIresDeviceCategoryFromSerialNumber(serialNumber) ===
      IresDeviceCategory.PANEL
      ? getPanel(serialNumber, true)
      : getComBox(serialNumber, true);
  }

  async loadIresDeviceAndAssignmentInfo() {
    const iresDevice = await this.loadIresDevice();
    
    if (iresDevice) {
      const clientId = getClientId();
    
      this.allDeviceAssignmentsToClient = await getAllAssignmentsOfCurrentClient(
        iresDevice.serialNo,
        clientId
      );

      const latestAssignmentEndDate = this.allDeviceAssignmentsToClient[0].endDate;

      //Device assignment is only permitted if the device is currently assigned to the client in question.
      if (latestAssignmentEndDate) {
        this.maxEndDate = latestAssignmentEndDate;   
      }

      if (!this.startedForAssignmentCreation) {
        this.updateMaxEndDate();
      }

      this.iresDevice = iresDevice;
      this.didLoadDeviceInfo = true;
    } else {
      return false;
    }

    const assignment = this.allDeviceAssignmentsToClient[this.allDeviceAssignmentsToClient.length-1];

    if (
      assignment &&
      (!this.minDate || assignment.startDate.seconds > this.minDate.seconds)
    ) {
      this.minDate = assignment.startDate;
    }

    return true;
  }

  updateMaxEndDate() {
    const nextAssignment = this.existingAssignments.filter((assignment) => 
      assignment.assignmentStartDate.toMillis() >= this.startDate.toMillis()
    )[0];

    // If there exists an assignment after the selected start date, limit the selection of the end date to the start date of the next assignment.
    if (nextAssignment && nextAssignment.assignmentStartDate.seconds < this.maxEndDate.seconds) {
      this.maxEndDate = nextAssignment.assignmentStartDate;
    }
  }

  async setupMeterReadingInfo() {
    if (this.startedForAssignmentCreation) {
      this.onStartDateChanged(toStartOfDay(this.startDate));
    } else {
      const meterReadingInfo = this.assignment.meterReadingInfo;

      if (meterReadingInfo) {
        if (meterReadingInfo.meterReadingStartKWh !== undefined) {
          this.meterReadingStart = {
            meterReadingInKWh: meterReadingInfo.meterReadingStartKWh,
            ignoreCorrectedBy: true,
          };
        }

        if (meterReadingInfo.meterReadingEndKWh !== undefined) {
          this.meterReadingEnd = {
            ignoreCorrectedBy: true,
            meterReadingInKWh: meterReadingInfo.meterReadingEndKWh,
          };
        }

        this.meterReadingStartCorrectedBy =
          meterReadingInfo.meterReadingStartCorrectedBy ?? null;

        this.meterReadingEndCorrectedBy =
          meterReadingInfo.meterReadingEndCorrectedBy ?? null;
      }
    }
  }

  get meterReadingStartInputInKwh() {
    return parseLocalizedFloat(this.meterReadingStartInput);
  }

  get meterReadingEndInputInKwh() {
    return parseLocalizedFloat(this.meterReadingEndInput);
  }

  async collectAssignmentInfo() {
    const assignmentUpdate = clone(this.assignment);
    const now = new Date();

    if (!assignmentUpdate.electricityMeterNumber && this.electricityMeterNumber) {
      assignmentUpdate.electricityMeterNumber = this.electricityMeterNumber;
    }

    assignmentUpdate.assignmentStartDate = toStartOfDay(this.startDate);
    assignmentUpdate.assignmentEndDate = this.endDate
      ? areDatesOnSameDay(this.endDate.toDate(), now)
        ? firestore.Timestamp.fromDate(now)
        : toEndOfDay(this.endDate)
      : null;

    // Validate counting device release constraints.
    if (this.isCountingDevice && assignmentUpdate.assignmentEndDate) {
      if (this.hasActiveDependentAssignments) {
        await this.confirmationDialog.show({
          title: this.$t("assignDevice.errorEndDateTitle").toString(),
          message: this.$t("assignDevice.countingDeviceHasActiveDependentsError").toString(),
          acceptMessage: null,
          rejectMessage: this.$t("common.abort").toString(),
        });
        return null;
      }

      const latestDependentEnd = this.latestDependentAssignmentEndDate;
      if (
        latestDependentEnd &&
        assignmentUpdate.assignmentEndDate.toMillis() < latestDependentEnd.toMillis()
      ) {
        await this.confirmationDialog.show({
          title: this.$t("assignDevice.errorEndDateTitle").toString(),
          message: this.$t("assignDevice.countingDeviceEndDateTooEarlyError", [
            formatDateShort(latestDependentEnd)
          ]).toString(),
          acceptMessage: null,
          rejectMessage: this.$t("common.abort").toString(),
        });
        return null;
      }
    }

    assignmentUpdate.meterReadingInfo = this.assignment.meterReadingInfo ?? {};

    const meterReadingStartKWh = this.meterReadingStartInputInKwh;
    const meterReadingEndKWh = this.meterReadingEndInputInKwh;
    if (
      this.endDate &&
      (isNaN(meterReadingEndKWh) || meterReadingStartKWh > meterReadingEndKWh)
    ) {
      this.meterReadingEndError = [
        this.$t("assignDevice.errorMeterReadingStart").toString(),
      ];
      return null;
    }

    if (this.doesPanelSupportIot && this.meterReadingEndCorrectedBy) {
      const result = await this.confirmationDialog.show({
        title: this.$t("assignDevice.meterReadingEndChanged").toString(),
        message: this.$t(
          "assignDevice.meterReadingEndChangedMessage"
        ).toString(),
        acceptMessage: this.$t("common.ok").toString(),
      });

      if (!result) {
        return null;
      }
    }

    if (!isNaN(meterReadingStartKWh)) {
      assignmentUpdate.meterReadingInfo.meterReadingStartKWh = meterReadingStartKWh;
    }

    if (!isNaN(meterReadingEndKWh) && this.endDate) {
      assignmentUpdate.meterReadingInfo.meterReadingEndKWh = meterReadingEndKWh;
    }

    const meterReadingStart =
      assignmentUpdate.meterReadingInfo.meterReadingStartKWh;

    const meterReadingEnd =
      assignmentUpdate.meterReadingInfo.meterReadingEndKWh;

    if (meterReadingStart !== undefined && meterReadingEnd !== undefined) {
      assignmentUpdate.powerConsumptionInKWh =
        meterReadingEnd - meterReadingStart;
    }

    assignmentUpdate.meterReadingInfo.meterReadingStartCorrectedBy =
      this.meterReadingStartCorrectedBy ?? undefined;
    assignmentUpdate.meterReadingInfo.meterReadingEndCorrectedBy =
      this.meterReadingEndCorrectedBy ?? undefined;

    return assignmentUpdate;
  }

  async showCollidingAssignmentInfo(
    date: firestore.Timestamp,
    collidingAssignment: ClientPanelAssignment
  ) {
    await this.confirmationDialog.show({
      title: this.$t("assignDevice.deviceAlreadyAssignedTitle").toString(),
      message: this.$t("assignDevice.deviceAlreadyAssignedMessage", [
        formatDateShort(date),
        collidingAssignment.assignmentEndDate
          ? formatDateShort(collidingAssignment.assignmentEndDate)
          : "-",
        collidingAssignment.assignedProjectName,
      ]).toString(),
      acceptMessage: null,
      rejectMessage: this.$t("common.abort").toString(),
    });
  }

  async saveAssignment() {
    const assignmentUpdate = await this.collectAssignmentInfo();

    if (!assignmentUpdate) {
      return false;
    }

    const programChains = this.startedForAssignmentCreation
      ? []
      : (
          await this.loadProgramChainsForAssignment(
            assignmentUpdate.assignmentStartDate,
            assignmentUpdate.assignmentEndDate
          )
        ).filteredProgramChains;

    if (this.startedForAssignmentCorrection) {
      await deleteClientPanelAssignments(this.targetProject, [
        assignmentUpdate,
      ]);
    }

    await saveOrUpdateClientPanelAssignment(
      assignmentUpdate,
      programChains,
      UserModule.activeUserIdentifier,
      UserModule.activeUserId ?? MASTER_ID
    );

    return true;
  }

  createEmptyMeterReadingInput() {
    return {
      canBeCorrected: true,
      meterReadingInKWh: 0,
    };
  }

  async onSave() {
    this.showProgressBar = true;

    const date = this.startedForAssignmentCreation
      ? this.startDate
      : this.endDate;

    if (!date) {
      this.showProgressBar = false;
      return;
    }

    let shouldValidateData = true;

    if (this.startedForAssignmentCreation) {
      shouldValidateData = !this.didValidateStartDate;
    } else {
      shouldValidateData = !this.didValidateEndDate;
    }

    if (shouldValidateData) {
      await this.validateAssignmentData(
        date,
        this.startedForAssignmentCreation
      );
    }

    if (
      this.assignmentValidationResult ===
      AssignmentValidationResult.SaveDisabled
    ) {
      this.showProgressBar = false;
      return;
    }

    const wasSaved = await this.saveAssignment();

    this.showProgressBar = false;

    if (wasSaved) {
      this.resetDialog();
      this.resolve && this.resolve(true);
    }
  }

  resetDialog() {
    this.baseDialogComponent.isShowing = false;
    this.showContent = false;

    this.existingAssignments = [];
    this.allDeviceAssignmentsToClient = [];

    this.didLoadDeviceInfo = false;
    this.minDate = null;

    this.startDate = firestore.Timestamp.fromDate(new Date());
    this.endDate = null;

    this.maxEndDate = firestore.Timestamp.fromDate(new Date());
    this.countedDeviceAssignments = [];
  }

  async loadCountedDeviceAssignments() {
    const [genericAssignments, panelAssignments] = await Promise.all([
      getGenericDeviceAssignmentsOfProject(this.targetProject.id),
      getClientPanelAssignmentsOfProject(this.targetProject.id),
    ]);

    const countedGeneric = genericAssignments.filter(
      (a) => a.externalElectricityMeterInfo?.assignmentId === this.assignment.id
    );
    const countedPanel = panelAssignments.filter(
      (a) => a.id !== this.assignment.id &&
        a.externalElectricityMeterInfo?.assignmentId === this.assignment.id
    );
    this.countedDeviceAssignments = [...countedGeneric, ...countedPanel];
  }

  onCancel() {
    this.resetDialog();
    this.resolve && this.resolve(false);
  }

  onMeterReadingStartManuallyChanged() {
    this.meterReadingStartCorrectedBy = getRecordInfo();
  }

  async validateMeterReadingStart() {
    if (this.meterReadingStartInput === "") {
      await this.onStartDateChanged(this.startDate, true);

      this.meterReadingStartCorrectedBy = null;
      this.meterReadingStart = this.proposedMeterReadingStart;
    }
  }

  validateMeterReadingEnd() {
    if (
      this.meterReadingEndInput === "" ||
      this.meterReadingEndInput === this.meterReadingStartInput
    ) {
      this.meterReadingEndCorrectedBy = null;

      // Restores the figure, not the lock: the proposal never carries `canBeCorrected`, so assigning
      // it whole disabled the field again on the first blur after it was cleared or typed back to
      // the start value.
      this.meterReadingEnd = restoreProposedMeterReading(
        this.meterReadingEnd,
        this.proposedMeterReadingEnd
      );
    }
  }

  onMeterReadingEndManuallyChanged() {
    this.meterReadingEndCorrectedBy = getRecordInfo();
  }

  get wasDeviceRecentlyActive() {
    return !didIresDeviceTimeOut(this.iresDevice);
  }

  async onActiveProgramChainStartedBeforeAssignmentEnd(
    assignmentEndDate: firestore.Timestamp,
    activeProgramChain: ProgramChain
  ) {
    const chainNumber = activeProgramChain.chainNumber;
    const formattedAssignmentEndDate = formatDateShort(assignmentEndDate);

    const formattedProgramChainStartDate = formatDateShort(
      activeProgramChain.startDate
    );

    let message = this.$t("openProgramChainDecision.message", [
      formattedAssignmentEndDate,
      chainNumber,
      formattedProgramChainStartDate,
      formattedAssignmentEndDate,
    ]).toString();

    if (this.wasDeviceRecentlyActive) {
      const warning = this.$t(
        "openProgramChainDecision.recentlyActiveDeviceWarning"
      ).toString();

      message = `${message}\n\n${warning}`;
    }

    const stopDrying = await this.confirmationDialog.show({
      title: this.$t("openProgramChainDecision.openProgramChain").toString(),
      message: message,
      acceptMessage: this.$t("openProgramChainDecision.stopDrying").toString(),
      rejectMessage: this.$t("common.abort").toString(),
    });

    const iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
      this.serialNumber
    );

    if (stopDrying) {
      if (iresDeviceCategory === IresDeviceCategory.COMBOX) {
        await createTerminateComBoxDryRunCommand(this.serialNumber);
      } else {
        const payload = buildStopPanelCommand();
        const requestType = IresDeviceRequestType.STOP_PROGRAM;

        await createPanelActionRequest(
          this.serialNumber,
          payload,
          false,
          requestType
        );
      }

      this.meterReadingEnd = {
        ...this.meterReadingEnd,
        canBeCorrected: true,
      };

      return AssignmentValidationResult.SaveEnabled;
    }

    return AssignmentValidationResult.SaveDisabled;
  }

  async onDelete() {
    const didConfirmDeletion = await this.confirmationDialog.show({
      title: this.$t("assignDevice.deleteAssignmentTitle").toString(),
      message: this.$t("assignDevice.deleteAssignmentMessage").toString(),
    });

    if (didConfirmDeletion) {
      await this.deleteThisAssignment();
    }
  }
}
